import fr from 'facet-rest';
import React, {
  useEffect,
} from 'react';
import useHomeContext
  from 'Context/HomeContext';
import useCollectionState
  from 'Hooks/useCollectionState';
import {
  UserLayout,
} from 'Views/Authentication/Layout/UserLayout';
import {
  AuthenticationLayoutLoading,
} from 'Views/Authentication/Components/AuthenticationLayoutLoading';
import {
  RoleSelectionLayout,
} from 'Views/Authentication/Layout/RoleSelectionLayout/RoleSelectionLayout';
import {
  MetaResourceRenderer,
} from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  buildFacetDesignOverride,
} from 'Packages/FacetRest/FacetDesignOverride';

export const RoleSelectionBaseLayout = () => {
  const [layoutType, setLayoutType] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const { homeResource } = useHomeContext();

  const collectionUrl = homeResource.withRelationship(fr.relationships.roleSelection.name, (rel) => {
    return rel.link('related').url();
  }, () => null);

  const {
    collection,
    setCollection,
  } = useCollectionState({ link: collectionUrl });

  useEffect(() => {
    switch (collection?.resources()?.head()?.type()) {
      case 'RoleSelectionPage':
        setIsLoading(false);
        setLayoutType('RoleSelectionLayout');
        break;
      case 'user':
        setIsLoading(false);
        setLayoutType('UserLayout');
        break;
      default:
    }
  }, [collection]);

  if (isLoading) {
    return <AuthenticationLayoutLoading />;
  }

  const Component = layoutType === 'UserLayout' ? UserLayout : RoleSelectionLayout;

  return (
    <MetaResourceRenderer
      key={collection?.resources()?.head()?.type()}
      resource={collection?.resources()?.head()}
      layout={Component}
      metaOverrideSet={buildFacetDesignOverride()}
      LayoutProps={{
        collection,
        setCollection,
      }}
    />
  );
};
